export default function getCollapsedStorageKey() {
  return 'carvana-merch-banner-collapsed';
}
